<div class="play-win-repeat">
    <mat-icon
        aria-hidden="true"
        class="back-icon"
        [ngStyle]="isBgImageLoading ? { color: '#000' } : { color: '#fff' }"
        (click)="closeDialog()"
        >arrow_back</mat-icon
    >
    <mat-icon
        aria-hidden="true"
        class="cross-icon"
        [ngStyle]="isBgImageLoading ? { color: '#000' } : { color: '#fff' }"
        (click)="closeDialog()"
        >clear</mat-icon
    >

    <ng-template [ngTemplateOutlet]="bgImage"></ng-template>
    <div class="content-wrapper">
        <ng-template [ngTemplateOutlet]="selectChoice"></ng-template>
        @if (showLottieAnimation) {
            <dotlottie-player autoplay="true" loop="false" class="confetti-container" src="{{ lottieUrl }}"> </dotlottie-player>
        }
        <ng-template [ngTemplateOutlet]="creditSection"></ng-template>
        <ng-template [ngTemplateOutlet]="howToPlay"></ng-template>
        <ng-template [ngTemplateOutlet]="tncWrapper"></ng-template>
    </div>
</div>

@if (!isChoiceLocked && selectedChoice) {
    <div class="lockin-wrapper center">
        <button class="lock-in" (click)="lockIn()">
            {{ ctaText }}
        </button>
    </div>
}

<ng-template #Checkmark>
    <div class="checkmark tick pull-right">
        <div class="checkmark_circle"></div>
        <div class="checkmark_stem"></div>
        <div class="checkmark_kick"></div>
    </div>
</ng-template>

<ng-template #bgImage>
    @if (isBgImageLoading) {
        <app-selector [height]="'340px'" [width]="'100%'"></app-selector>
    }
    <img [src]="bgImageUrl" (load)="isBgImageLoading = false" [hidden]="isBgImageLoading" class="bg-image" />
</ng-template>

<ng-template #selectChoice>
    <div class="select-choice-container">
        @if (isLoading) {
            <app-selector [height]="'12px'" [width]="'50%'"></app-selector>
            <app-selector [height]="'32px'" [width]="'100%'" [style]="{ 'margin-bottom': '20px' }"></app-selector>
            <app-selector [height]="'40px'" [width]="'47%'" [style]="{ 'margin-right': '6%' }"></app-selector>
            <app-selector [height]="'40px'" [width]="'47%'"></app-selector>
        }

        @if (!isLoading) {
            <span [innerHTML]="gameDetails.header_html"></span>
            <div class="choices">
                @for (choice of choices; track choice) {
                    <button
                        class="choice center"
                        (click)="!isChoiceLocked && changeChoice(choice.code)"
                        [ngStyle]="
                            choice.code === selectedChoice
                                ? {
                                      background: isChoiceLocked ? '#FFB800' : '#F2F3F4',
                                      border: isChoiceLocked ? '' : '1px solid #0C0D0D'
                                  }
                                : {}
                        ">
                        @if (choice.code === selectedChoice) {
                            @if (isChoiceLocked) {
                                <img class="tick" src="{{ DEPLOY_URL }}/assets/images/lock-option.svg" />
                            }
                            @if (!isChoiceLocked) {
                                <ng-template [ngTemplateOutlet]="Checkmark"></ng-template>
                            }
                        }
                        {{ choice.text }}
                    </button>
                }
            </div>
            @if (gameDetails.active_order && !isChoiceLocked && choices.length) {
                <div>
                    *Your choice will be mapped to the current order. You don't have to place another order to lock in your
                    choice.
                </div>
            }
        }
    </div>
</ng-template>

<ng-template #creditSection>
    @if (isLoading) {
        <app-selector [height]="'86px'" [width]="'100%'" [style]="{ 'border-radius': '12px' }"></app-selector>
    }

    @if (gameDetails.earned_credit; as credit) {
        <div class="credit-wrapper" (click)="navigateToCredit()">
            <div style="width: 100%">
                <span class="credit-title">Credits Won On EatClub Games</span>
                <mat-icon aria-hidden="true" style="float: right; color: #fff; margin-top: -3px">navigate_next</mat-icon>
            </div>
            <div class="credit-info-details center">
                <img class="coin" src="{{ DEPLOY_URL }}/assets/images/credit-coin.png" />
                <span class="bal">{{ credit | number }}</span>
            </div>
        </div>
    }
</ng-template>

<ng-template #howToPlay>
    @if (isHowToPlayLoading) {
        <app-selector [height]="'320px'" [width]="'100%'" [style]="{ 'border-radius': '12px' }"></app-selector>
    }
    <img [src]="howToPlayImageUrl" (load)="isHowToPlayLoading = false" [hidden]="isHowToPlayLoading" class="how-to-play" />
</ng-template>

<ng-template #tncWrapper>
    @if (tnc) {
        <div class="pwr-tnc-wrapper">
            @if (!isTncLoading) {
                <div [innerHTML]="tnc" class="tnc-content"></div>
            }
        </div>
    }
</ng-template>
